import ContentGraphArticle from './contentGraph/ContentGraphArticle';

const CONDENSED_GAME = 'condensed-game';
const DATA_VISUALIZATION = 'data-visualization';
const GAME_RECAP = 'game-recap';

class ContentGraphModel {
    constructor (data, params) {
        this.data = data?.data?.getGamesByGamePks?.[0]?.content || {};
        this.params = params;
        this.parseData();
    }

    parseData () {
        const { videoContent: videos = [], recapArticle: recap = [], relatedArticles = [] } = this.data;

        this.parseVideos(videos);
        this.parseRecap(recap[0]);
        this.parseHighlightsByTypes(videos);
        this.parseRelatedArticles(relatedArticles);
    }

    parseVideos (videos = []) {
        const playVideoMap = {};
        for (const video of videos) {
            const { guid } = video;
            if (guid) {
                playVideoMap[guid] = video;
            }
            // The URLs are returned in an object.
            video.templateUrl = video?.thumbnail?.templateUrl;
        }
        this.playVideoMap = playVideoMap;
    }

    parseHighlightsByTypes (highlights) {
        let gameRecap;
        let condensedGame;
        const dataViz = [];
        const filteredHighlights = [];

        highlights?.forEach(highlight => {
            const tags = highlight?.tags;
            let isHighlight = true;
            const cloned = { ...highlight };

            if (tags && tags?.length > 0) {
                tags.forEach(tag => {
                    const tagSlug = tag?.slug;
                    if (!tagSlug) {
                        return;
                    }

                    if (tagSlug === GAME_RECAP) {
                        cloned.videoType = 'recap';
                        gameRecap = cloned;
                        isHighlight = false;
                    } else if (tagSlug === CONDENSED_GAME) {
                        cloned.videoType = 'condensedGame';
                        condensedGame = cloned;
                        isHighlight = false;
                    } else if (tagSlug === DATA_VISUALIZATION) {
                        cloned.videoType = 'dataViz';
                        dataViz.push(cloned);
                        isHighlight = false;
                    }
                });
            }

            if (isHighlight) {
                cloned.videoType = 'highlights';
                filteredHighlights.push(cloned);
            }
        });

        this.highlightsByTypes = {
            highlights: filteredHighlights,
            gameRecap,
            condensedGame,
            dataViz
        };
    }

    parseRecap (recap = {}) {
        const {
            slug,
            headline,
            blurb,
            templateUrl,
            id,
            isDataLoaded
        } = recap;
        const linkId = id ? `c-${id}` : slug;
        this.recap = {
            slug,
            headline,
            blurb,
            linkId,
            templateUrl,
            isDataLoaded
        };
    }

    parseRelatedArticles (list) {
        this.articles = [];
        this.articlesById = [];
        if (list && list.length) {
            let i = 0;
            const len = list.length;
            let article;

            for (; i < len; i++) {
                article = new ContentGraphArticle(list[i], false);
                if (article.slug && article.isRecap === false && article.isPreviewStory === false) {
                    this.articles.push(article);
                    this.articlesById[article.slug] = article;
                }
            }
        }
    }
}

export default ContentGraphModel;
